import React from "react";
import PropTypes from "prop-types";
import { CopyText } from "../CopyText";

function ImprintPersonName({ children: name, ...otherProps }) {
  return (
    <CopyText tag="span" variants={CopyText.Variant.highlight} {...otherProps}>
      {name}
    </CopyText>
  );
}

ImprintPersonName.propTypes = {
  children: PropTypes.node.isRequired,
};

ImprintPersonName.displayName = "Imprint.Person.Name";

export default ImprintPersonName;
